/**
 *
 * Create by liaokai on 2020-04-17 11:25:11
 */
import * as React from 'react';
import {Component} from "react";
import {RouteComponentProps} from "react-router";
import SetCashWay from "./index"
import {SurfaceRouter, tSurfaceRouteItem} from "../../../../components/surface-router/surface-router";

interface IProps extends RouteComponentProps{

}

interface IState{

}

const routerData : tSurfaceRouteItem = {
    breadTitle : "收款设置",
    routeName : "",
    component : SetCashWay,
    children : []
};

export class SetCashWayRouter extends Component<IProps,IState>{
    readonly state : IState = {

    };
    render() {
        let {} = this.props;
        let {} = this.state;
        return (
            <SurfaceRouter {...this.props} entryRoute={routerData}/>
        );
    }
}
